// extracted by mini-css-extract-plugin
export default {"end":"BriefInfo_end__PvBYB","mobileEnd":"BriefInfo_mobileEnd__XMf0V","greylink":"BriefInfo_greylink__n4gTw","root":"BriefInfo_root__g2+-G"};